import React from "react"
import { ClienteDto } from "../../generated"
import CustomersStore from "../../customers/customersStore";

interface Props {
    id: number | undefined | null;
    template: (cliente: ClienteDto) => JSX.Element | string | number;
}

export const CustomerData: React.FC<Props> = ({ id, template }) => {
    if (!id)
        return null;
    const cliente = CustomersStore.use(id)
    if (cliente == null) return null;
    return <>{template(cliente)}</>;
}